import { lazy } from "react";
import type { ReactElement } from "react";
import type { PageRouteId } from "@/routes/routeManifest";

const HomePage = lazy(() =>
  import("@/pages/HomePage").then((module) => ({ default: module.HomePage })),
);
const PricingPage = lazy(() =>
  import("@/pages/PricingPage").then((module) => ({
    default: module.PricingPage,
  })),
);
const LegalDocumentsPage = lazy(() =>
  import("@/pages/LegalDocumentsPage").then((module) => ({
    default: module.LegalDocumentsPage,
  })),
);
const LegalTermsPage = lazy(() =>
  import("@/pages/LegalTermsPage").then((module) => ({
    default: module.LegalTermsPage,
  })),
);
const LegalPrivacyPolicyPage = lazy(() =>
  import("@/pages/LegalPrivacyPolicyPage").then((module) => ({
    default: module.LegalPrivacyPolicyPage,
  })),
);
const LegalWorkspacePrivacyPage = lazy(() =>
  import("@/pages/LegalWorkspacePrivacyPage").then((module) => ({
    default: module.LegalWorkspacePrivacyPage,
  })),
);
const LegalCompanyDetailsPage = lazy(() =>
  import("@/pages/LegalCompanyDetailsPage").then((module) => ({
    default: module.LegalCompanyDetailsPage,
  })),
);
const LegalSubscriptionPage = lazy(() =>
  import("@/pages/LegalSubscriptionPage").then((module) => ({
    default: module.LegalSubscriptionPage,
  })),
);
const LegalPersonalDataConsentPage = lazy(() =>
  import("@/pages/LegalPersonalDataConsentPage").then((module) => ({
    default: module.LegalPersonalDataConsentPage,
  })),
);
const AccountPage = lazy(() =>
  import("@/pages/AccountPage").then((module) => ({
    default: module.AccountPage,
  })),
);
const PublicUiPage = lazy(() =>
  import("@/pages/PublicUiPage").then((module) => ({
    default: module.PublicUiPage,
  })),
);
const UsersPage = lazy(() =>
  import("@/pages/UsersPage").then((module) => ({ default: module.UsersPage })),
);
const UserDetailPage = lazy(() =>
  import("@/pages/UserDetailPage").then((module) => ({
    default: module.UserDetailPage,
  })),
);
const LoginPage = lazy(() =>
  import("@/pages/LoginPage").then((module) => ({ default: module.LoginPage })),
);
const RegisterPage = lazy(() =>
  import("@/pages/RegisterPage").then((module) => ({
    default: module.RegisterPage,
  })),
);
const NotFoundPage = lazy(() =>
  import("@/pages/NotFoundPage").then((module) => ({
    default: module.NotFoundPage,
  })),
);
const ConfirmEmailPage = lazy(() =>
  import("@/pages/ConfirmEmailPage").then((module) => ({
    default: module.ConfirmEmailPage,
  })),
);
const ForgotPasswordPage = lazy(() =>
  import("@/pages/ForgotPasswordPage").then((module) => ({
    default: module.ForgotPasswordPage,
  })),
);
const ResetPasswordPage = lazy(() =>
  import("@/pages/ResetPasswordPage").then((module) => ({
    default: module.ResetPasswordPage,
  })),
);
const RealmDomainLoginPage = lazy(() =>
  import("@/pages/RealmDomainLoginPage").then((module) => ({
    default: module.RealmDomainLoginPage,
  })),
);
const ProjectDetailPage = lazy(() =>
  import("@/pages/ProjectDetailPage").then((module) => ({
    default: module.ProjectDetailPage,
  })),
);
const OrganizationDetailPage = lazy(() =>
  import("@/pages/OrganizationDetailPage").then((module) => ({
    default: module.OrganizationDetailPage,
  })),
);
const ProfilePage = lazy(() =>
  import("@/pages/ProfilePage").then((module) => ({
    default: module.ProfilePage,
  })),
);

export const routeElements: Record<PageRouteId, ReactElement> = {
  home: <HomePage />,
  pricing: <PricingPage />,
  legal: <LegalDocumentsPage />,
  legalTerms: <LegalTermsPage />,
  legalPrivacy: <LegalPrivacyPolicyPage />,
  legalWorkspacePrivacy: <LegalWorkspacePrivacyPage />,
  legalCompanyDetails: <LegalCompanyDetailsPage />,
  legalSubscription: <LegalSubscriptionPage />,
  legalPersonalDataConsent: <LegalPersonalDataConsentPage />,
  account: <AccountPage />,
  accountComponent: <AccountPage />,
  profile: <ProfilePage />,
  realmDomainLogin: <RealmDomainLoginPage />,
  projectDetail: <ProjectDetailPage />,
  organizationDetail: <OrganizationDetailPage />,
  elementStore: <PublicUiPage />,
  users: <UsersPage />,
  userDetail: <UserDetailPage />,
  register: <RegisterPage />,
  login: <LoginPage />,
  confirmEmail: <ConfirmEmailPage />,
  forgotPassword: <ForgotPasswordPage />,
  resetPassword: <ResetPasswordPage />,
  notFound: <NotFoundPage />,
};
